/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Scan Icon component.
 */
export const SystemScanIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.54545 2H2.5C2.22386 2 2 2.22386 2 2.5V6.54545' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M18.3637 22L22.4092 22C22.6853 22 22.9092 21.7761 22.9092 21.5L22.9092 17.4545' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M22.9092 6.54545L22.9092 2.5C22.9092 2.22386 22.6853 2 22.4092 2L18.3637 2' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M2 17.4545L2 21.5C2 21.7761 2.22386 22 2.5 22L6.54545 22' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='6.75' y1='6.75' x2='6.75' y2='17.0682' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='10.3862' y1='6.75' x2='10.3862' y2='17.0682' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='14.0229' y1='6.75' x2='14.0229' y2='17.0682' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='18.5684' y1='6.75' x2='18.5684' y2='17.0682' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export default SystemScanIcon;
